import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DateTimeService } from '../../services/date-time.service';
import { DateFormat } from '../../interfaces/base-core-services.interface';
import { StorageService } from '../../services/storage.service';
import { UserInfoService } from '../../services/user-info.service';
import { FormDrawerService } from '../../services/form-drawer.service';
import { RiskFeedbackComponent } from './risk-feedback/risk-feedback.component';

import * as _ from 'lodash';
import { RiskFeedback } from '../../interfaces/risk-feedback.interface';


@Component({
  selector: 'app-inspection-approval',
  templateUrl: './inspection-approval.component.html',
  styleUrls: ['./inspection-approval.component.less']
})
export class InspectionApprovalComponent implements OnInit {
  public inspectionApprovalGroup: FormGroup;
  public inspectionStatusList: any[] = [];
  public rejectionReasonList: any[] = [];
  public actionTypeList: any[] = [];
  public referDepartmentList: any[] = [];
  public formData:any = { 'variables': {} };
  public goodsDetailAction= [];
  public load = false;
  public inspectionStatusNotCleared = false;
  public currentDate = new Date();
  public inspectionTo:any;
  public inspectionFrom:any = this.currentDate;
  public showrejectionReason = false;
  public showActionType = false;
  public showRemarks = false;
  public submitBtnName: string = "Submit";
  public riskFeedbackList: RiskFeedback[] = [];
  public riskTypeList: any[] = [
    {
      label: "No Risk Found",
      code: "NORISK",
    },
    {
      label: "Risk Found",
      code: "RISKFOUND",
    },
    {
      label: "New Risk Found",
      code: "NEWRISK",
    },
  ];

  currentRiskFeedback: RiskFeedback;
  showReferDepartment  = false;
  @Input() public defaultFormData: string[];
  @Input() public cType: string;
  @Input() referenceNumber: any;
  @Output() public submitedFormData = new EventEmitter<FormData>();
  @Output() public openRiskAssesmentReport = new EventEmitter<any>();
  readonly INSPECTION_STATUS = {
    CLEARED: 'Cleared',
    REFER_TO_DEPT: 'Refer to other department.'
  }
  readonly RISKTYPE = {
    NEWRISK: 'NEWRISK'
  }
  newRiskFound: boolean;

  constructor(private formBuilder: FormBuilder,
    private dataTimeService: DateTimeService,
    private storage: StorageService,
    private formDrawerService: FormDrawerService,
    public userInfo: UserInfoService) { }

  ngOnInit() :void {
    if (typeof this.defaultFormData === 'object') {
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }

  onLoad(data:any):void  {
    this.inspectionApprovalGroup = this.formBuilder.group({
      riskType: [null, [Validators.required]],
      inspectionStatus: [null, [Validators.required]],
      actionType: [null],
      rejectionReason: [null],
      referDepartment: [null],
      timeRange: [[this.currentDate], [Validators.required]],
      remarks: [null]
    });

    const keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      if (key.indexOf('mitigation') >= 0) {
        this.inspectionStatusList = data.rdmData[key];
      } else if (key.indexOf('rejectionreason') >= 0) {
        this.rejectionReasonList = data.rdmData[key];
      } else if (key.indexOf('ics-action-type') >= 0) {
        this.actionTypeList = data.rdmData[key];
      } else if (key.indexOf('ics-transfer-dept') >= 0) {
        this.referDepartmentList = data.rdmData[key];
      }
    });
    this.inspectionApprovalGroup.controls.timeRange.valueChanges.subscribe((res:any)=>{
      this.inspectionFrom = this.dataTimeService.getDateFormat(res[0].getTime(), DateFormat.DATE_TIME);
      this.inspectionTo = this.dataTimeService.getDateFormat(res[1].getTime(), DateFormat.DATE_TIME);
    })
  }

  onOpenRiskAssesmentReport(){
    this.openRiskAssesmentReport.emit(true);
  }

  inspectionStatusChange(value: string):void  {
    const insStatus = this.inspectionApprovalGroup.controls['inspectionStatus'];
    const rejStatus = this.inspectionApprovalGroup.controls['rejectionReason'];
    const appRemark = this.inspectionApprovalGroup.controls['remarks'];
    const actionType = this.inspectionApprovalGroup.controls['actionType'];
    if( value != '' && value != this.INSPECTION_STATUS.CLEARED){
      this.inspectionStatusNotCleared = true;
    } else{
      this.inspectionStatusNotCleared =false;
    }

    if (value.includes('Cleared')) {
      this.showrejectionReason = false;
      this.showActionType = false;
      insStatus.setValidators(Validators.required);
      rejStatus.clearValidators();
      appRemark.clearValidators();
      actionType.clearValidators();
      actionType.reset();
      rejStatus.reset();
    } else if (value.includes('Reject')) {
      this.showrejectionReason = true;
      this.showActionType = false;
      rejStatus.setValidators([Validators.required]);
      appRemark.setValidators([Validators.required]);
      insStatus.clearValidators();
      actionType.clearValidators();
      actionType.reset();
    } else if (value.includes('Detained') || value.includes('Seized')) {
      this.showrejectionReason = false;
      this.showActionType = true;
      actionType.setValidators([Validators.required]);
      insStatus.clearValidators();
      rejStatus.clearValidators();
      appRemark.clearValidators();
      rejStatus.reset();
    }
     else {
      this.showrejectionReason = false;
      this.showActionType = false;
      rejStatus.clearValidators();
      insStatus.clearValidators();
      actionType.clearValidators();
    }
    this.submitBtnName = value.includes('Detained') ? 'Detain' : value.includes('Seized') ? 'Seize' : 'Submit';
    this.showReferDepartment = false;
    if(value == this.INSPECTION_STATUS.REFER_TO_DEPT){
      this.showReferDepartment = true;
    }

  }

  onRiskTypeChanges(value:string):void{
      this.newRiskFound = value===this.RISKTYPE.NEWRISK ? true:false;
  }
  onOk(result: any|Date): void {
    this.inspectionFrom = this.dataTimeService.getDateFormat(result[0].getTime(), DateFormat.DATE_TIME);
    this.inspectionTo = this.dataTimeService.getDateFormat(result[1].getTime(), DateFormat.DATE_TIME);
  }
  onChange(result: Date[]): void {
    this.inspectionFrom = this.dataTimeService.getDateFormat(result[0].getTime(), DateFormat.DATE_TIME);
    this.inspectionTo = this.dataTimeService.getDateFormat(result[1].getTime(), DateFormat.DATE_TIME);
  }

  openFeedbackDrawer():void {
    this.formDrawerService.openDrawerForm(RiskFeedbackComponent,'Add Feedback').subscribe((result: { value: { sourceRefName: string; }; }) => {
      if (result) {
        const riskFeedback = result.value as RiskFeedback;
        riskFeedback.sourceRefName = 'INSPECTION_CASE_DETAIL';
        this.riskFeedbackList.push(riskFeedback);
        this.riskFeedbackList = [...this.riskFeedbackList];
      }
    });
  }


  onSubmit():void  {
    for (const i in this.inspectionApprovalGroup.controls) {
      if(i in this.inspectionApprovalGroup.controls){
        this.inspectionApprovalGroup.controls[i].markAsDirty();
        this.inspectionApprovalGroup.controls[i].updateValueAndValidity();
      }
    }

    if (this.inspectionApprovalGroup.value.inspectionStatus !== null) {
      this.formData.variables['insCaseStatus'] = {'value' : this.inspectionApprovalGroup.value.inspectionStatus  };
    }

    if (this.inspectionApprovalGroup.value.referDepartment !== null) {
      this.formData.variables['referDepartment'] = {"value" : this.inspectionApprovalGroup.value.referDepartment  }
    }

    if (this.inspectionApprovalGroup.value.rejectionReason !== null) {
      this.formData.variables['insCaseFurtherAction'] = {'value' : this.inspectionApprovalGroup.value.rejectionReason };
    }


    if (this.inspectionFrom !== null && this.inspectionFrom !== undefined) {
      this.formData.variables['inspectionDateFrom'] = {'value' : this.inspectionFrom };
    } else {
      this.inspectionApprovalGroup.controls.timeRange.setErrors({ 'required': true });
    }

    if (this.inspectionTo !== null && this.inspectionTo !== undefined) {
      this.formData.variables['inspectionDateTo'] =  {'value' :this.inspectionTo };
    } else {
      this.inspectionApprovalGroup.controls.timeRange.setErrors({ 'required': true });
    }

    if (this.inspectionApprovalGroup.value.remarks !== null) {
      this.formData.variables['remarks'] = {'value' : this.inspectionApprovalGroup.value.remarks };
    }

    this.formData.variables['riskFeedbacks'] = {'value' : this.riskFeedbackList };
    this.formData.variables['riskType'] = {'value' : this.inspectionApprovalGroup.value.riskType };

    this.formData.variables['insCaseActionType'] = {'value' : this.inspectionApprovalGroup.value.actionType };

    if (this.inspectionApprovalGroup.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }


  editFeedback(index: number): void {
    this.currentRiskFeedback = this.riskFeedbackList[index];
    this.formDrawerService.openDrawerForm(RiskFeedbackComponent, 'Update Feedback', this.currentRiskFeedback).subscribe((result: { value:any; }) => {
      if (result) {
        const changedData = _.fill( this.riskFeedbackList,result.value,index,index+1);
        this.riskFeedbackList = [...changedData];
      }
    });
  }


  deleteFeedback(index:any):void  {
    this.riskFeedbackList.splice(index, 1);
    this.riskFeedbackList = [...this.riskFeedbackList];
  }

  cancel(): void {
    return;
  }

}
